import { render, staticRenderFns } from "./CompanionViewAll.vue?vue&type=template&id=0ac19a6f&scoped=true&lang=pug&"
import script from "./CompanionViewAll.vue?vue&type=script&lang=js&"
export * from "./CompanionViewAll.vue?vue&type=script&lang=js&"
import style0 from "./CompanionViewAll.vue?vue&type=style&index=0&id=0ac19a6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac19a6f",
  null
  
)

export default component.exports